import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import AllRoutes from "./router/AllRoutes";
import ScrollToTop from "./components/ScrollToTop";
import AOS from "aos";
import "aos/dist/aos.css";
import "photoswipe/dist/photoswipe.css";
import "bootstrap/dist/js/bootstrap";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);
  window.addEventListener("load", AOS.refresh);

  return (
    <>
      <Helmet>
        <title>Gotong Royong: Platform Kolaborasi Global</title>
        <meta property="og:site_name" content="gotong-royong" />
        <meta
          property="og:url"
          content="https://themeforest.net/user/ib-themes"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Gotong-Royong: Platform Kolaborasi Global"
        />
        <meta
          name="keywords"
          content="Gotong royong, platform kolaborasi sosial, komunitas, kerja sama, bantu membantu, solidaritas sosial, kegiatan komunitas, dampak sosial, mutual assistance, community collaboration platform"
        />
        <meta
          name="description"
          content="Gotong Royong adalah platform inovatif yang menghubungkan diaspora dengan komunitas lokal di Indonesia, memfasilitasi kolaborasi, dan memperkuat kontribusi mereka dalam pembangunan sosial dan ekonomi tanah air."
        />
        <meta name="description" content="Platform Koloborasi Global" />
      </Helmet>
      {/* End Seo Helmt */}

      <ScrollToTop />
      {/* End Scroll top */}

      <AllRoutes />
    </>
  );
};

export default App;
